import { FC } from 'react';

import { Box, Stack, Typography } from '@thirdspacelearning/library';

import { MaintenanceFlag } from '../types';

import maintenanceSvg from '../assets/maintenance.png';

const sx = {
    root: {
        width: '100%',
        height: '100vh',
        alignItems: 'center',
        justifyContent: 'center',
    },
    text: {
        whiteSpace: 'pre-line',
        textAlign: 'center',
    },
};

type Props = {
    flag: MaintenanceFlag;
};

const MaintenancePage: FC<Props> = ({ flag }) => {
    const { title, message, eta, contact } = flag;

    return (
        <Stack gap={2} sx={sx.root}>
            <Box mt={2}>
                <img src={maintenanceSvg} alt="maintenance" />
            </Box>
            <Typography variant="h5" fontWeight="bold">
                {title ? title : 'Our site is under maintenance'}
            </Typography>
            <Typography color="grey.600" sx={sx.text}>
                {message
                    ? message
                    : `We're currently undergoing scheduled maintenance. \nDuring this time the site will be temporarily unavailable.`}
            </Typography>
            <Typography color="grey.600" sx={sx.text}>
                {`We'll be back up and running ${eta || 'soon'}. Thank you for your patience!`}
            </Typography>
            <Typography color="grey.600" sx={sx.text}>
                {`For urgent queries, feel free to reach out to our team:\n${contact || '0203 771 0096'}`}
            </Typography>
        </Stack>
    );
};

export default MaintenancePage;
